export function FallbackAvatar() {
  return (
    <svg
      viewBox="0 0 100 100"
      width="100%"
      height="100%"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="100" height="100" rx="18" fill="#F7F8FB" />
      <rect
        x="0.5"
        y="0.5"
        width="99"
        height="99"
        rx="17.5"
        fill="none"
        stroke="#D8DDE8"
      />
      <circle cx="50" cy="33" r="16.5" fill="#B8BFCC" />
      <path
        d="M22 77C25.8 63.8 37 56 50 56C63 56 74.2 63.8 78 77C70.5 83 60.9 86.5 50 86.5C39.1 86.5 29.5 83 22 77Z"
        fill="#B8BFCC"
      />
    </svg>
  );
}
